import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/ShowActivitySettingsStore';
import ShowActivitySettingsContainer from '../containers/ShowActivitySettingsContainer';

// See documentation for https://github.com/reactjs/react-redux.
// This is how you get props from the Rails view into the redux store.
// This code here binds your smart component to the redux store.
const ShowActivitySettingsApp = (props) => (
  <Provider store={configureStore(props)}>
    <ShowActivitySettingsContainer />
  </Provider>
);

export default ShowActivitySettingsApp;
